import { ref, reactive } from 'vue'

export default () => {
  interface F {
    shopItemSkuId: string;
    productSku: string,
    itemRemark: string
    combinationProductSku:string
    oemProductSku: string
  }

  type k = 'shopItemSkuId' | 'productSku' | 'itemRemark' | 'combinationProductSku' | 'oemProductSku'
  const form: F = reactive({
    shopItemSkuId: '',
    productSku: '',
    itemRemark: '',
    combinationProductSku: '',
    oemProductSku: ''
  })

  const setForm = (value: any, key: k) => { form[key] = value }

  return {
    form,
    setForm
  }
}
